import {
  createContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from 'react';
import { useNavigate } from 'react-router';

import Spinner from 'components/Spinner';
import TokenService from 'utils/tokenService';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [auth, setAuth] = useState(null);

  const authLogin = useCallback((token) => {
    TokenService.setToken(token);
    const user = {
      user_id: '137d2a30-7981-4808-a9c9-f70f958266c0',
      roles: [2001, 1984, 5150],
    };
    localStorage.setItem('begig-user', JSON.stringify(user));
    setAuth(user);
  }, []);

  const authLogout = useCallback(() => {
    TokenService.clearToken();
    setAuth(null);
    localStorage.removeItem('begig-user');
  }, []);

  useEffect(() => {
    const checkAuthStatus = () => {
      const user = localStorage.getItem('begig-user');
      const token = TokenService.getToken();
      
      if (!user || !token) {
        authLogout();
        navigate('/auth/login', { replace: true });
      } else {
        try {
          const parsedUser = JSON.parse(user);
          // Compare key properties instead of full object
          if (auth?.user_id !== parsedUser?.user_id) {
            setAuth(parsedUser); // Update only when necessary
          }
        } catch (error) {
          console.error('Error parsing user data:', error);
          authLogout();
          navigate('/auth/login', { replace: true });
        }
      }
      setLoading(false);
    };

    checkAuthStatus();
  }, [auth, navigate, authLogout]);

  const contextValue = useMemo(
    () => ({
      auth,
      authLogin,
      authLogout,
    }),
    [auth, authLogin, authLogout]
  );

  return (
    <AuthContext.Provider value={contextValue}>
      {isLoading ? <Spinner /> : children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
